import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@jsverse/transloco';
import { UserAccountModule } from '@precisely/prism-ng/user-account';
import { ButtonDirective } from 'primeng/button';
import { appWindow } from '../AppWindow';
import { AuthorizationModule } from '../authorization/authorization.module';
import { FeatureFlagsModule } from '../core/feature-flags/feature-flags.module';
import { HelpModule } from '../help/help.module';
import { EnterpriseConfigurationModule } from '../shared/modules/enterprise-configuration/enterprise-configuration.module';
import { AuthenticatedHeaderComponent } from './authenticated-header/authenticated-header.component';
import { HeaderShadowDirective } from './header-shadow.directive';
import { HeaderComponent } from './header/header.component';
import { IfRestrictAccessDirective } from './if-restrict-access.directive';
import { UnauthenticatedHeaderComponent } from './unauthenticated-header/unauthenticated-header.component';

@NgModule({
  declarations: [
    AuthenticatedHeaderComponent,
    IfRestrictAccessDirective,
    UnauthenticatedHeaderComponent,
    HeaderShadowDirective,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    FeatureFlagsModule,
    EnterpriseConfigurationModule,
    HelpModule,
    AuthorizationModule,
    TranslocoModule,
    UserAccountModule,
    ButtonDirective,
  ],
  providers: [{ provide: 'window', useValue: appWindow }],
})
export class HeaderModule {}
